import { GwrGebaeudeListEntry, GwrgebaeudeService, GwrGrundstueckNummerListEntry } from '../../../core/gwr-api';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { Location, NgTemplateOutlet } from '@angular/common';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { environment } from '../../../../environments/environment';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { KompaktGwrGrundstueckPipe } from '../../../shared/kompaktdarstellung/gwr/kompakt-gwr-grundstueck.pipe';
import { KompaktGwrGebaeudeeingangsadressePipe } from '../kompakt-gebaeudeeingangsadresse-pipe';

@Component({
  selector: 'cap-gwr-gebaeude-table',
  templateUrl: './gwr-gebaeude-table.component.html',
  styleUrls: ['./gwr-gebaeude-table.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    ColumnHeaderComponent,
    NgbTooltip,
    LinkComponent,
    TranslatePipe,
    KompaktGwrGrundstueckPipe,
    KompaktGwrGebaeudeeingangsadressePipe
  ]
})
export class GwrGebaeudeTableComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input()
  title = 'GefundeneGebäude';

  @Input()
  showZeilenSelect = true;

  @Input()
  showTotal = true;

  private _listLoader: ListLoader<GwrGebaeudeListEntry>;

  externerGwrLink: string = environment.gwrServerUrl + '?egid=';

  tableSortModel = new TableSortModel<GwrGebaeudeListEntry>('table', this.comparatorService);

  maxGrundstueckeProGebaeude = 3;

  constructor(
    private gwrGebaeudeService: GwrgebaeudeService,
    private stateService: SearchStateService,
    protected router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private location: Location,
    private comparatorService: ComparatorService
  ) {
    super();
    keysToTranslate<GwrGebaeudeListEntry.GebaeudeStatusEnum>(['PROJEKTIERT', 'IM_BAU', 'BESTEHEND', 'ABGEBROCHEN']);
    keysToTranslate<string>(['GefundeneGebäude']);
    this.tableSortModel
      .addColumn('EGID', (a, b) => this.comparatorService.orderByComparator(a.egid, b.egid), undefined)
      .switchSortDirection();
    this.tableSortModel.addColumn(
      'versicherungsNummer',
      (a, b) => this.comparatorService.orderByComparator(a.versicherungsNummer, b.versicherungsNummer),
      undefined
    );
    this.tableSortModel.addColumn(
      'gebaeudeStatus',
      (a, b) => this.comparatorService.orderByComparator(a.gebaeudeStatus, b.gebaeudeStatus),
      undefined
    );
  }

  @Input()
  set listLoader(value: ListLoader<GwrGebaeudeListEntry>) {
    if (!value) {
      return;
    }
    value.applySortModel(this.tableSortModel);
    this._listLoader = value;
  }

  get listLoader(): ListLoader<GwrGebaeudeListEntry> {
    return this._listLoader;
  }

  getGrundstueckQueryParams(grundstueckNummer: GwrGrundstueckNummerListEntry) {
    const params = [];
    params['bfs'] = grundstueckNummer.gemeinde && grundstueckNummer.gemeinde.bfsNummer;
    params['n1'] = grundstueckNummer.nummer;
    params['n2'] = grundstueckNummer.nummerZusatz;
    params['n3'] = grundstueckNummer.nummer3;
    params['n4'] = grundstueckNummer.nummer4;
    return params;
  }

  hasExternalGwrLink(): boolean {
    return environment.gwrServerUrl !== null;
  }

  openExternalGWRLink(egid: string) {
    if (this.hasExternalGwrLink()) {
      window.open(this.externerGwrLink + egid, '_blank');
    }
  }

  ngOnInit(): void {}
}
